import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]
  declare dialogTarget: HTMLDialogElement

  open(): void {
    this.dialogTarget.showModal()
  }

  close(): void {
    this.dialogTarget.close()
  }

  clickOutside(event: MouseEvent): void {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }
}
